import { useState, useEffect } from 'react';
import FooterService from '../components/user/common/services/FooterService';

export const useFooter = (page = 'all') => {
    const [footerSections, setFooterSections] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchFooterStructure = async () => {
            try {
                setLoading(true);
                setError(null);
                
                const response = await FooterService.getFooterStructure(page);
                
                if (response.status) {
                    setFooterSections(response.data);
                }
            } catch (err) {
                setError(err.message);
                console.error('Error fetching footer structure:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchFooterStructure();
    }, [page]);

    return {
        footerSections,
        loading,
        error
    };
};